import { Stack } from '@mui/material'
import React from 'react'

import NumericInput from 'src/components/Input/NumericInput'

interface IProps {
  clearable?: boolean
  disableFuture?: boolean
  disabled?: boolean
  error?: boolean
  label?: string
  locale?: string
  max?: number
  min?: number
  onChange: (value: number | undefined) => void
  value: number | undefined
}

const RangedInput = (props: IProps) => {
  const { value, onChange, label, min, max, error, disabled } = props
  const [forceRender, setRerender] = React.useState<boolean>(false)

  const onValueChange = (e: any) => {
    let val = parseInt(e, 10)
    if (max) {
      val = Math.min(val, max)
      setRerender(!forceRender)
    } else if (min) {
      val = Math.max(val, min)
      setRerender(!forceRender)
    }
    onChange(val)
  }

  const pickerProps = {
    value,
    onChange: onValueChange,
    label,
    error,
    disabled,
  }

  return (
    <Stack>
      <NumericInput inputType={'text'} {...pickerProps} bufferNeedUpdate={forceRender} />
    </Stack>
  )
}

export default RangedInput
